import React, { useEffect, useState } from 'react';

const BackToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hero = document.getElementById('hero');
    if (!hero) return;

    const onScroll = () => {
      setVisible(window.scrollY > hero.offsetHeight);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollTop}
      aria-label="Back to top"
      style={{
        position: 'fixed',
        bottom: 30,
        right: 30,
        width: 56,
        height: 56,
        borderRadius: '50%',
        border: 'none',
        backgroundColor: '#f76c0d', // vibrant orange
        boxShadow: '0 4px 10px rgba(247, 108, 13, 0.5)',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'background-color 0.3s ease',
        zIndex: '9',
      }}
      onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#e8f8f5')} // light mint on hover
      onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#f76c0d')}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        fill="none"
        stroke="#fff"  // white arrow
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        viewBox="0 0 24 24"
        style={{ transform: 'rotate(-90deg)' }} // arrow pointing up
      >
        <polyline points="6 4 18 12 6 20" />
      </svg>
    </button>
  );
};

export default BackToTopButton;
